import styled from '@emotion/styled'
import { gapY } from '@mobi/component-library/Utils/gap'
import { spacing } from '@mobi/component-library/Theme/Common'

export const SignUpPageStyled = styled.div(
  {
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateRows: 'min-content 1fr min-content',
    minHeight: '100%',
    padding: '2.2rem 2rem 2rem',
  },
  gapY(spacing.bigx3)
)

export const Content = styled.div(
  {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  gapY(spacing.bigx1)
)

export const Footer = styled.div(
  {
    flex: '0 0 100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'top',
  },
  gapY(spacing.sm)
)
